import { Component, OnInit, ViewChild } from "@angular/core";
import {
  DatoPaginadoModel,
  Paging,
} from "src/app/shared/models/dato-paginado.model";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { CampoAdicionalCategoriaService } from "./campo-adicional-categoria.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ModalConfirmarRespuestaComponent } from "src/app/shared/layouts/modal-confirmar-respuesta/modal-confirmar-respuesta.component";
import {
  ConfirmarRespuestaModel,
  ConfirmarRespuestaType,
} from "src/app/shared/models/confirmar-respuesta.model";
import { MatOption } from "@angular/material/core";

@Component({
  selector: "app-campo-adicional-categoria",
  templateUrl: "./campo-adicional-categoria.component.html",
  styleUrls: ["./campo-adicional-categoria.component.scss"],
})
export class CampoAdicionalCategoriaComponent implements OnInit {
  @ViewChild('allSelected') private allSelected: MatOption;

  dataTabla: DatoPaginadoModel;
  headerCampoAdicionalCategoria: Array<string>;
  formCampoAdicionalCategoria: FormGroup;
  selectCampoAdicionalCategoria: any;
  paginaActual: number;

  // filtros
  filtro: FormGroup;
  public isCollapsed = true;

  // Selects
  campoAdicional: Array<any> = [];
  categoria: Array<any> = [];

  constructor(
    private formBuilder: FormBuilder,
    private campoAdicionalCategoriaService: CampoAdicionalCategoriaService,
    private modalService: NgbModal
  ) {
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;

    this.createForm();
    this.selectCampoAdicionalCategoria = null;
    this.paginaActual = 1;
  }

  ngOnInit() {
    this.headerCampoAdicionalCategoria = [
      "Campo Adicional ID",
      "Campo Adicional",
      "Categoria ID",
      "Categoria",
      "Estado",
      "Acción",
    ];
    this.consultarListas();
    this.onConsultarCampoAdicionalCategoria(1);
  }

  createForm() {
    this.formCampoAdicionalCategoria = this.formBuilder.group({
      campo_adicional_id: [null, Validators.required],
      categoria: [null, Validators.required],
      //aplica_Comerciante: [false, Validators.requiredTrue],
      //aplica_No_Comerciante: [false, Validators.requiredTrue],
      Descripcion_Campo_Adicional: [null],
      Descripcion_Categoria: [null],
      activo: [true]
    });

    this.filtro = this.formBuilder.group({
      campo_adicional_id: [null, Validators.required],
      categoria_id: [null, Validators.required],
      activo: [null],
    });
  }

  consultarListas() {
    this.campoAdicionalCategoriaService
      .getCampoAdicional()
      .subscribe((resultado) => {
        if (resultado.data) {
          this.campoAdicional = resultado.data;
        }
      });

    this.campoAdicionalCategoriaService
      .getCategoria()
      .subscribe((resultado) => {
        if (resultado.result) {
          this.categoria = resultado.data;
        }
      });
  }

  onConsultarCampoAdicionalCategoria(page: number) {
    this.campoAdicionalCategoriaService
      .get({ ...this.filtro.value, numeroPagina: page })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.dataTabla = resultado.data as DatoPaginadoModel;
        }
      });
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarCampoAdicionalCategoria(value);
  }

  //category
  categoryResult() {
    let categoryArray = this.formCampoAdicionalCategoria.controls.categoria.value.filter((category : any) => category > 0);
    return [...categoryArray.map((category : any) => { return { Categoria_Id : category } })];
  }

  selectAllCategories() {
    let categoryArray = [];
    if (this.allSelected.selected) {
      categoryArray = [...this.categoria.map((category) => category.categoria_id), 0];
      this.formCampoAdicionalCategoria.controls.categoria.setValue([...categoryArray]);
    } else {
      this.allSelected.deselect();
      this.formCampoAdicionalCategoria.controls.categoria.setValue(null);
    }
  }

  allCategories() {
    if (this.allSelected.selected) {
      this.allSelected.deselect();
      return false;
    }
    if(this.formCampoAdicionalCategoria.controls.categoria.value.length === this.categoria.length)
      this.allSelected.select();
  }
  //category

  //commercial
  commercialResult( check? : boolean, commercialType? : string ) {
    if (commercialType === 'aplica_Comerciante') {
      this.formCampoAdicionalCategoria.controls['aplica_No_Comerciante'].clearValidators();
    } else {
      this.formCampoAdicionalCategoria.controls['aplica_Comerciante'].clearValidators();
    }

    if (!check) {
      if (!this.formCampoAdicionalCategoria.controls['aplica_Comerciante'].value &&
      !this.formCampoAdicionalCategoria.controls['aplica_No_Comerciante'].value) {

        this.formCampoAdicionalCategoria.controls['aplica_Comerciante'].setValue(false);
        this.formCampoAdicionalCategoria.controls['aplica_No_Comerciante'].setValue(false);

        this.formCampoAdicionalCategoria.controls['aplica_Comerciante'].setValidators(Validators.requiredTrue);
        this.formCampoAdicionalCategoria.controls['aplica_No_Comerciante'].setValidators(Validators.requiredTrue);
      }
    }

    this.formCampoAdicionalCategoria.controls['aplica_No_Comerciante'].updateValueAndValidity();
    this.formCampoAdicionalCategoria.controls['aplica_Comerciante'].updateValueAndValidity();
  }
  //commercial

  //campo adicional Categoria
  onOperarCampoAdicionalCategoria() {
    this.formCampoAdicionalCategoria.controls.categoria.setValue(this.categoryResult());

    (!this.selectCampoAdicionalCategoria)
      ? this.onAgregarCampoAdicionalCategoria()
      : this.onModificarCampoAdicionalCategoria();
  }

  onAgregarCampoAdicionalCategoria() {
    this.campoAdicionalCategoriaService
      .create({
        ...this.formCampoAdicionalCategoria.value,
        activo: 1,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.onConsultarCampoAdicionalCategoria(this.paginaActual);
          this.limpiarCampoAdicionalCategoria();
        }
      });
  }

  onModificarCampoAdicionalCategoria() {
    this.campoAdicionalCategoriaService
      .update({
        ...this.formCampoAdicionalCategoria.value,
        categoria_id: this.selectCampoAdicionalCategoria.categoria_id,
        campo_adicional_id: this.selectCampoAdicionalCategoria
          .campo_adicional_id,
      })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.limpiarCampoAdicionalCategoria();
          this.onConsultarCampoAdicionalCategoria(this.paginaActual);
        }
      });
  }

  onCargarCampoAdicionalCategoria(entry: any) {
    entry.activo = entry.activo ? 1 : 0;
    this.formCampoAdicionalCategoria.setValue({
      Descripcion_Campo_Adicional: entry.descripcion_campo_adicional,
      Descripcion_Categoria: entry.descripcion_categoria,
      activo: entry.activo,
      //aplica_Comerciante: entry.Aplica_Comerciante,
      //aplica_No_Comerciante: entry.Aplica_No_Comerciante,
      campo_adicional_id: entry.campo_adicional_id,
      categoria: [entry.categoria_id]
    });

    //this.commercialResult( entry.Aplica_Comerciante, 'aplica_Comerciante' );
    //this.commercialResult( entry.Aplica_No_Comerciante, 'aplica_No_Comerciante' );
    this.selectCampoAdicionalCategoria = entry;
    this.formCampoAdicionalCategoria.get("categoria_id")?.disable();
    this.formCampoAdicionalCategoria.get("campo_adicional_id")?.disable();
  }

  onEliminarCampoAdicionalCategoria(entry: any) {
    const modalRef = this.modalService.open(ModalConfirmarRespuestaComponent, {
      centered: true,
    });
    const confirmarRespuesta = {} as ConfirmarRespuestaModel;
    confirmarRespuesta.type = ConfirmarRespuestaType.Atencion;
    confirmarRespuesta.message = `¿Está seguro de eliminar la configuración seleccionada?`;
    modalRef.componentInstance.confirmarRespuesta = confirmarRespuesta;
    modalRef.result.then(() => {
      this.campoAdicionalCategoriaService
        .delete(entry)
        .subscribe((resultado) => {
          if (resultado.result) {
            this.onConsultarCampoAdicionalCategoria(this.paginaActual);
            this.selectCampoAdicionalCategoria = null;
            this.formCampoAdicionalCategoria.reset();
          }
        });
    });
  }

  limpiarCampoAdicionalCategoria() {
    this.formCampoAdicionalCategoria.get("categoria").enable();
    this.formCampoAdicionalCategoria.get("campo_adicional_id").enable();
    this.formCampoAdicionalCategoria.reset();
    this.selectCampoAdicionalCategoria = null;
    this.createForm();
  }
  //campo adicional Categoria

  //filtro
  filtrar() {
    this.paginaActual = 1;
    this.onConsultarCampoAdicionalCategoria(1);
  }

  limpiar() {
    this.filtro.reset();
    this.filtrar();
  }
  //filtro
}
